import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getCurrentSystemBannerAction } from "../../actions/SystemBannersActions";
import { connect } from "react-redux";

function SystemBanner({ getCurrentSystemBannerAction }) {
  const [data, setData] = useState();
  const [banner, setBanner] = useState(false);
  const [Title, setTitle] = useState("");
  const [Checkboxflag, setCheckboxflag] = useState(false);
  const currentDate = new Date();
  const lastOpenedDate = localStorage.getItem("lastOpenedDate");
  const firstOpen = localStorage.getItem("firstOpen");
  const bannerDisplayed = localStorage.getItem("bannerDisplayed");

  useEffect(() => {
    changeStatus();
  }, []);

  function changeStatus() {
    getCurrentSystemBannerAction()
      .then((response) => {
        if (Array.isArray(response.data) && response.data.length > 0) {
          //   console.log("response.data-23", response);
          setData(response.data[0].message);
          setTitle(response.data[0].title);
          //   console.log("2.", lastOpenedDate !== currentDate.toDateString());
          //   console.log("3.", firstOpen == "true");

          if (!localStorage.getItem("bannerDisplayed")) {
            // console.log("banner display not found");
            localStorage.setItem("bannerDisplayed", false);
          } else {
            // console.log("banner display  found");
          }

          if (
            (lastOpenedDate !== currentDate.toDateString() ||
              firstOpen == "true") &&
            bannerDisplayed == "false"
          ) {
            // Update the last opened date in local storage
            localStorage.setItem("lastOpenedDate", currentDate.toDateString());
            localStorage.setItem("firstOpen", false);
            localStorage.setItem("bannerDisplayed", true);
            // Your condition logic here
            setBanner(true);
          }
        } else {
          setBanner(false);
          localStorage.setItem("firstOpen", true);
          localStorage.setItem("bannerDisplayed", false);
        }
      })
      .catch((err) => {
        console.log(err);
        setBanner(false);
      });
  }

  function onCancel() {
    setBanner(false);
    if (!Checkboxflag) {
      localStorage.setItem("firstOpen", true);
    }
  }

  function handleChange(e) {
    // console.log("====e=====", e.target.checked);
    setCheckboxflag(!Checkboxflag);
    if (e.target.checked) {
      localStorage.setItem("firstOpen", false);
    } else {
      localStorage.setItem("firstOpen", true);
    }
  }

  return (
    <Modal
      show={banner}
      onHide={() => onCancel()}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
      className="modal-med modal-400 modal-delete"
      centered
      backdrop={false}
    >
      <Modal.Header closeButton style={{ paddingTop: 0 }}>
        <h5>{Title}</h5>
      </Modal.Header>
      <Modal.Body className="pb-0 ">
        <div dangerouslySetInnerHTML={{ __html: data }} />
      </Modal.Body>
      <Modal.Footer>
        <input
          type="checkbox"
          checked={Checkboxflag}
          onChange={(e) => {
            handleChange(e);
          }}
        />
        <span>Do not show for today. </span>
      </Modal.Footer>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    getCurrentSystemBannerAction,
  }
)(SystemBanner);
